import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";

export class StockTransferReportData extends ReportData<StockTransferReportData> {
    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
}
